import React from "react";
import Intro from "./components/intro/Intro";
import About from "./components/About";
import Content from "./components/intro/Content";
import Phone from "./components/intro/Phone";
import Footer from "./components/intro/Footer";
import Toogle from "./components/toggle/Toogle";
import SlideData from "./components/intro/SlideData";
import { ThemeContext } from "./Context";
import Images from "./components/intro/Images";
import { useContext } from "react";
import Video from "./components/intro/Video";

const App = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div
      style={{
        backgroundColor: darkMode ? "#222" : "whitesmoke",
        color: darkMode && "white",
      }}
    >
      <Toogle />
      <Intro />
      <Images />
      <Video />
      <SlideData />
      <About />
      <Content />
      <Phone />
      <Footer />
    </div>
  );
};

export default App;
